import { render, staticRenderFns } from "./dashActivity.vue?vue&type=template&id=25915956&scoped=true&"
import script from "./dashActivity.vue?vue&type=script&lang=js&"
export * from "./dashActivity.vue?vue&type=script&lang=js&"
import style0 from "./dashActivity.vue?vue&type=style&index=0&id=25915956&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25915956",
  null
  
)

export default component.exports